import React, { useCallback } from 'react';
import { Form, Input, Button, message } from 'antd';
import { KeyOutlined, CopyOutlined } from '@ant-design/icons';

const LicenseKeyField = ({ isEdit, form }) => {
  const generateLicenseKey = useCallback(() => {
    const key = `SYG-${Math.random().toString(36).substring(2, 10).toUpperCase()}-${Math.random().toString(36).substring(2, 10).toUpperCase()}`;
    form.setFieldsValue({ license_key: key });
  }, [form]);

  const copyLicenseKey = useCallback(() => {
    const licenseKey = form.getFieldValue('license_key');
    if (!licenseKey) {
      message.warning('No license key to copy');
      return;
    }
    navigator.clipboard.writeText(licenseKey)
      .then(() => message.success('License key copied to clipboard'))
      .catch(() => message.error('Failed to copy license key'));
  }, [form]);

  return (
    <Form.Item
      label="License Key"
      name="license_key"
      rules={[{ required: true, message: 'Please generate a license key' }]}
      extra={
        <div style={{ marginTop: 8, display: 'flex', gap: '8px' }}>
          <Button 
            type="primary"
            onClick={generateLicenseKey}
            icon={<KeyOutlined />}
            disabled={isEdit}
          >
            Generate
          </Button>

          <Button 
            onClick={copyLicenseKey}
            icon={<CopyOutlined />}
            disabled={form.getFieldValue('license_key')}
          />
        </div>
      }
    >
      
      <Input 
        placeholder="Click 'Generate License Key' to create a license key" 
        readOnly={true}
        style={{ color: 'rgba(0, 0, 0, 0.65)' }}
      />
    </Form.Item>
  );
};

export default LicenseKeyField;
